<template>
    <div>
        <img :src="require('@/assets/img/contact/dekouple.png')" class="dekouple-logo" />
    </div>
</template>

<script></script>

<style scoped>
.dekouple-logo {
    max-width: 300px;
}
</style>